const FALLBACK_TIMEOUT = 30000;

export { FALLBACK_TIMEOUT };
